import React, { useContext, useState } from 'react'
import styles from "./Navbar.module.css"
import Logo from "../../assets/Logo.jpg"
import { NavLink, useLocation, useNavigate } from 'react-router-dom'
import GlobalStorage from '../../Storage/ContextProvider'
import { GiHamburgerMenu } from "react-icons/gi";
import { RxCross1 } from "react-icons/rx";
function Navbar(props) {
  const navigate = useNavigate()
  const location = useLocation()
  const { scrol, setScroll } = useContext(GlobalStorage)
  const onScroll = () => {
    const Scrolled = document.documentElement.scrollTop;
    const MaxHeight =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;
  };
  window.addEventListener("scroll", onScroll);
  return (
    <div className={`${styles.navbar}`}>
      <div className={styles.navLogo}>
        <img style={{ cursor: 'pointer' }} onClick={() => navigate('/')} src={Logo} alt="" />

      </div>
      <div className={styles.navItem}>
        <ul >
          <li  ><NavLink to='/why-us' className={location.pathname === '/why-us' ? styles.activeTab : ""} style={{ color: "#066263" }}>WHY US</NavLink></li>
          <li ><NavLink to='/about' className={location.pathname === '/about' ? styles.activeTab : ""} style={{ color: "#066263" }}>ABOUT US</NavLink></li>
          <li><NavLink to='/approaches' className={location.pathname === '/approaches' ? styles.activeTab : ""} style={{ color: "#066263" }}>APPROACH</NavLink></li>
          <li><NavLink to='/service-work' className={location.pathname === '/service-work' ? styles.activeTab : ""} style={{ color: "#066263" }}>SERVICES</NavLink></li>
          <li><a target='_blank' href='https://www.canva.com/design/DAFiTsBqbJ4/ObTRtfVcovm9IUHIhmo8HQ/view?utm_content=DAFiTsBqbJ4&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink'className={location.pathname === '/portfolio' ? styles.activeTab : ""}  style={{ color: "#066263" }}>PORTFOLIO</a></li>
          <li><NavLink to='/contact' className={location.pathname === '/contact' ? styles.activeTab : ""}  style={{ color: "#066263" }}>CONTACT</NavLink></li>
        </ul>
        <div onClick={(e) => { props.setShowNav('showNavbody'); e.stopPropagation() }} className={styles.hamburgerMenu}>
          <GiHamburgerMenu />
        </div>
      </div>




      <div className={`${styles.sideNavBody} ${props.showNav}`}>
        <div onClick={() => { props.setShowNav('sideNav') }} className={styles.SideCross}>
          <RxCross1 />
        </div>
        <ul >
          <li  ><NavLink to='/why-us' className={location.pathname === '/why-us' ? styles.activeTabSide : ""} style={{ color: "#066263" }}>WHY US</NavLink></li>
          <li ><NavLink to='/about' className={location.pathname === '/about' ? styles.activeTabSide : ""} style={{ color: "#066263" }}>ABOUT US</NavLink></li>
          <li><NavLink to='/approaches' className={location.pathname === '/approaches' ? styles.activeTabSide : ""} style={{ color: "#066263" }}>APPROACH</NavLink></li>
          <li><NavLink to='/service-work' className={location.pathname === '/service-work' ? styles.activeTabSide : ""} style={{ color: "#066263" }}>SERVICES</NavLink></li>
          <li><a target='_blank' href='https://www.canva.com/design/DAFiTsBqbJ4/ObTRtfVcovm9IUHIhmo8HQ/view?utm_content=DAFiTsBqbJ4&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink'className={location.pathname === '/portfolio' ? styles.activeTab : ""}  style={{ color: "#066263" }}>PORTFOLIO</a></li>
          <li><NavLink to='/contact' className={location.pathname === '/contact' ? styles.activeTab : ""}  style={{ color: "#066263" }}>CONTACT</NavLink></li>
        </ul>
      </div>


    </div>
  )
}

export default Navbar